import React, { useEffect, useState } from "react";
// import img from "../../assets/rocket.png";
import { FaArrowRight, FaCheckCircle, FaChevronDown, FaChevronUp, FaCircle } from "react-icons/fa";
import "./webdevelopment.css";
import { FaCircleCheck, FaCircleDollarToSlot, FaCircleDot, FaCircleHalfStroke, FaCircleQuestion, FaRegCircleDot } from "react-icons/fa6";
import img from "../../assets/services images/software-testing.jpg";
import img1 from "../../assets/services images/web-features.png";
import img2 from "../../assets/services images/solutions-1-768x768.png"
import AOS from 'aos';
import 'aos/dist/aos.css';

function Softwaretesting() {
    const [openIndex, setOpenIndex] = useState(0);

    const features = [
        {
            title: "Manual Testing",
            content: "Our testers simulate real-world user interactions, identifying issues that could affect the functionality and user experience of your application.",
        },
        {
            title: "Automated Testing",
            content: "We use automated testing tools to streamline repetitive tasks, improve test accuracy, and reduce testing time while ensuring optimal software performance.",
        },
        {
            title: "Functional Testing",
            content: "We verify that all features and functionalities of your software work as expected, ensuring your application performs its intended tasks without errors.",
        },
        {
            title: "Usability Testing",
            content: "We assess how user-friendly and intuitive your software is, identifying areas for improvement to enhance user satisfaction.",
        },
        {
            title: "Compatibility Testing",
            content: "We test your software across different devices, browsers, and operating systems to ensure compatibility and a consistent experience for all users.",
        },
          {
            title: "Security Testing",
            content: "Our team performs thorough security checks to identify vulnerabilities, ensuring your software is safe from potential cyber threats and data breaches.",
        },
          {
            title: "Performance Testing",
            content: "We evaluate how well your software performs under various conditions, ensuring it can handle high traffic and large-scale usage without compromising performance.",
        },
    ];

    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = (index) => {
        // If already active, close it — otherwise open
        setActiveIndex(activeIndex === index ? null : index);
    };

    const services = [
        {
            title: "Expertise",
            desc: "Our skilled team of testers is experienced in using the latest testing tools and methodologies to ensure your software is of the highest quality.",
        },
        {
            title: "Comprehensive Coverage",
            desc: "We provide end-to-end testing services, covering all aspects of your software, from functionality to security.",
        },
        {
            title: "Cost-Effective Solutions",
            desc: "We identify and fix issues early in the development process, saving you time and money by preventing costly post-deployment problems.",
        },
          {
            title: "Seamless Intergration",
            desc: "Our testing services can be integrated into your existing development cycle, ensuring minimal disruption to your project timeline.",
        },
    ];



    const toggleFeature = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

      useEffect(() => {
    AOS.init({
      duration: 1200, // fade duration for all (ms)
      easing: "ease-in-out", // smooth effect
      once: true,
    });
  }, []);

    return (
        <>

            <section className="service-section1">
                <div className="service-section1-container">
                    {/* Left side - text */}
                    <div className="text-headers" data-aos="fade-down">
                        <div className="title-line">
                            <FaCircleDot style={{ color: "#ffffff", marginRight: "8px" }} />
                            <h4>Software Testing</h4>
                        </div>
                        <div className="breadcrumb-line">
                            <span>
                                <a href="/home">Home</a> » <a href="/contact">Software Testing</a>
                            </span>
                        </div>
                    </div>



                </div>
            </section>

            <div className="container">

                <section className="main-services-section-all">
                    <div className="main-services-container">

                        {/* Left side - image */}
                        <div className="main-services-image"  data-aos="fade-left">
                            <img src={img} alt="Software Testing" />
                        </div>

                        {/* Right side - text */}
                        <div className="main-services-content"data-aos="fade-right">
                            <h1>Software Testing Service</h1>

                            <p>
                               Ensure your software performs flawlessly with REDITE’s expert software testing services. Our team provides thorough, reliable, and efficient testing solutions that identify and resolve issues before your application reaches your users. We focus on delivering high-quality, secure, and user-friendly applications, ensuring they meet the highest standards for functionality, security, and performance.
                            </p>

                            <h3>Comprehensive Testing for Flawless Performance</h3>


                            <p>
                               At REDITE, we use a combination of manual and automated testing to deliver comprehensive solutions for your software. Our testing services ensure your application is bug-free, secure, and optimized across all platforms, offering your users a seamless experience. Whether you’re launching a new application or updating an existing one, we make sure your software works perfectly every time.
                            </p>
                        </div>

                    </div>
                </section>

                <section className="webdev-section">
                    <div className="webdev-container">
                        {/* Left - Accordion Section */}
                        <div className="webdev-left" data-aos="fade-right">
                            <h3>
Our Software Testing Services Include:</h3>

                            {features.map((feature, index) => (
                                <div
                                    key={index}
                                    className={`accordion-item ${openIndex === index ? "active" : ""}`}
                                    onClick={() => toggleFeature(index)}
                                >
                                    <div className="accordion-title">
                                        <span>
                                            {index + 1}. {feature.title}:
                                        </span>
                                        {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                                    </div>

                                    {/* SVG Shape only for active accordion */}
                                    {openIndex === index && (
                                        <svg
                                            version="1.1"
                                            className="svg-shape"
                                            viewBox="0 0 541 64"
                                            height="64"
                                            preserveAspectRatio="none"
                                        >
                                            <polygon
                                                className="path"
                                                points="85,55 81,55 51,55 42.5,64 34,55 0,55 0,0 34.4,0 42.5,9.5 50.6,0 81,0 85,0 541,0 541,55 "
                                            ></polygon>
                                        </svg>
                                    )}

                                    {openIndex === index && (
                                        <div className="accordion-content">
                                            <p>{feature.content}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Right - Image */}
                        <div className="webdev-right" data-aos="fade-left">
                            <img src={img1} alt="Software Testing Illustration" />
                        </div>
                    </div>
                </section>
                <section className="web-dev-section">
                    <div className="web-dev-container">
                        {/* Left Side Image */}
                        <div className="web-dev-left" data-aos="fade-up">
                            <img src={img2} alt="Software Testing" />
                        </div>

                        {/* Right Side Content */}
                        <div className="web-dev-right" data-aos="fade-down">
                            <h4>Why Choose REDITE for Software Testing?</h4>

                            {services.map((item, index) => (
                                <div
                                    key={index}
                                    className={`web-dev-box ${activeIndex === index ? "active" : ""}`}
                                    onClick={() => handleClick(index)}
                                >
                                    <div className="web-dev-box-header">
                                        <FaCheckCircle className="icon" />
                                        <h5>{item.title}:</h5>
                                    </div>

                                    {activeIndex === index && (
                                        <p className="web-dev-desc">{item.desc}</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="all-services-page">
                    <div className="all-services-container" data-aos="fade-left">
                        <h4>Our Approach: Quality-Driven Testing</h4>
                        <p>
                     REDITE follows a structured, quality-driven approach to software testing. From initial test planning to post-deployment checks, we work closely with you to ensure your software meets industry standards and user expectations. Our transparent reporting and actionable insights provide you with clear guidance for improvement.
                        </p>

                        <h4>Ready to Ensure Your Software’s Quality?</h4>
                        

                        <p>
                           Trust REDITE to provide comprehensive software testing services that guarantee your applications are ready for success.
                            <span> Contact us today</span>to learn how we can help you deliver reliable, secure, and high-performance software to your users.
                        </p>
                    </div>
                </section>

            </div>
        </>
    );
}

export default Softwaretesting;
